import { head } from 'lodash/fp';
import { Card, LocalizedSectionTitle, SpacingMediumBottom, SpacingMediumTopBottom } from '@mews-commander/ui';
import { TextKey } from '@mews-commander/enums';
import { matchTimeUnitKey } from '@mews/framework';
import { Service } from '@mews-commander/data-access';
import { getData, isDayUse } from '@mews-commander/utils';
import { GuestsTable, ResourcesTable } from '../ReservationsOverview';
import { DisplayPrintOnly } from './style';
import { PrintableOverviewProps } from './types';

const listServiceResourceTables = (services: Service[]) => {
    const service = head(services);
    if (service === undefined) return null;
    const { timeUnit } = getData(service);
    const timeUnitKey = matchTimeUnitKey({ isServiceDayUse: isDayUse(service), timeUnit, plural: true });
    const resourceTables = services.map(({ id: serviceId }) => (
        <ResourcesTable serviceId={serviceId} key={serviceId} />
    ));
    return (
        <Card>
            <SpacingMediumTopBottom>
                <LocalizedSectionTitle textKey={timeUnitKey || TextKey.NightPlural} />
            </SpacingMediumTopBottom>
            {resourceTables}
        </Card>
    );
};

type VoidFunction = (prop: string) => void;

const listServiceGuestsTables =
    (editProfile: VoidFunction, billingScreen: VoidFunction, editInternals: VoidFunction) => (serviceId: string) => (
        <GuestsTable
            editProfile={editProfile}
            billingScreen={billingScreen}
            editInternals={editInternals}
            serviceId={serviceId}
        />
    );

const PrintableOverview = ({
    isFetching,
    hasFailed,
    editProfile,
    billingScreen,
    editInternals,
    timeGroupedServices,
    checkedServiceIds,
}: PrintableOverviewProps) => {
    if (isFetching || hasFailed) {
        return null;
    }

    const resourcesTable = Object.values(timeGroupedServices).map(listServiceResourceTables);
    const guestsTable = checkedServiceIds.map(listServiceGuestsTables(editProfile, billingScreen, editInternals));

    return (
        <DisplayPrintOnly>
            {resourcesTable}
            <SpacingMediumBottom />
            <Card>
                <SpacingMediumTopBottom>
                    <LocalizedSectionTitle textKey={TextKey.ResourcePlural} />
                </SpacingMediumTopBottom>
                {guestsTable}
            </Card>
        </DisplayPrintOnly>
    );
};

export default PrintableOverview;
